import {
    format,
    formatDistance,
    isValid,
    subDays,
    addDays
} from 'date-fns'

export function getStationCode() {
    const params = new URLSearchParams(window.location.search);
    const nodeId =  params.get('stationCode');
    return nodeId ? {stationCode: nodeId}:{};
}

export function getStartTime() {
   return subtractDaysFromCurrentDate(1);
}

export function getCurrentTime() {
    return new Date();
}

export function getRelativeTime(timestamp) {
    if(isValid(timestamp)) {
        return `${formatDistance(new Date(timestamp), new Date())} ago`;
    }
    return ``;
}

export function getFormattedDate(pattern) {
    return format(new Date(), pattern);
}

export function getFormattedByEpochDate(date, pattern) {
    if(date===0) return "";
    return format(new Date(date), pattern);
}

export function filterObject(initial, keys) {
    return keys.reduce((obj, key) => ({ ...obj, [key]: initial[key] }), {})
}

export function URIEncoder(params) {
    return Object
        .entries(params || {})
        .reduce((obj, [key, value]) =>
            (Array.isArray(value)
                ? [...obj, ...value.map(v => [`${key}[]`, v])]
                : [...obj, [key, value]]), [])
        .map(([key, val]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(val)}`)
        .join('&');
}

export function subtractDaysFromCurrentDate(amount) {
    return subDays(getCurrentTime(), amount);
}

export function addDaysToCurrentDate(amount, pattern) {
    return format(addDays(getCurrentTime(), amount), pattern);
}

export function getUTCTimeFromDate(date, hours, minutes) {
    var localDate = new Date(date);
    localDate.setHours(hours);
    localDate.setMinutes(minutes);
    return localDate.getTime() / 1000;
}

export function getNodeId() {
    const params = new URLSearchParams(window.location.search);
    const nodeId =  params.get('stationCode');
    return nodeId ? {nodeId: nodeId}:{};
}

export function isDebugMode() {
    return false
}


// WEBPACK FOOTER //
// ./src/components/util/NetworkUtil.js